<template>
    <PageSidebar>
        <template #sidebarTitle>
            <span>{{ $t("legal.menu.nda") }} </span>
        </template>
        <template #sidebarCta>
            <ButtonSecondarySm @click="$emit('add')">
                <AddIcon />
                <span>{{ $t("love.reviews_list.new") }}</span>
            </ButtonSecondarySm>
        </template>
        <template #sidebarMain>
            <div class="p-6 space-y-3">
                <NdaCard
                    v-for="nda in ndas"
                    :key="nda.title"
                    :nda="nda"
                    @click="$emit('edit', nda)"
                    @edit="$emit('edit', nda)"
                    @duplicate="cloneNda(nda)"
                    @delete="askAndRemoveNda(nda)"
                    @generate="generateNda(nda)"
                />
                <CardEmpty
                    class="w-full"
                    v-if="!ndas.length"
                    :title="$t('legal.nda.empty.title')"
                    :icon="emptyIcon"
                    :ctaLabel="$t('legal.nda.empty.cta')"
                    @add="$emit('add')"
                />
            </div>
        </template>
    </PageSidebar>
</template>

<script>
import { markRaw } from "vue";
import { mapState, mapMutations, mapActions } from "vuex";
import { ButtonSecondarySm } from "@easy/ui/buttons";
import { AddIcon, TextFileIcon } from "@easy/ui/icons";
import { PageSidebar } from "@easy/ui/page-components";
import { CardEmpty } from "@easy/ui/cards";
import NdaCard from "./NdaCard.vue";

export default {
    components: {
        PageSidebar,
        ButtonSecondarySm,
        AddIcon,
        CardEmpty,
        NdaCard,
    },
    emits: ["add", "edit"],
    created() {
        this.getNdas();
    },
    data() {
        return {
            waitForIframeAndGeneratePdf: false,
        };
    },
    watch: {
        iframeLoaded(value) {
            if (value && this.waitForIframeAndGeneratePdf) {
                setTimeout(() => {
                    this.generatePdf();
                    this.waitForIframeAndGeneratePdf = false;
                }, 300);
            }
        },
    },
    computed: {
        ...mapState("legal", ["iframeLoaded"]),
        ...mapState("legal/ndas", ["ndas", "nda"]),
        emptyIcon() {
            return markRaw(TextFileIcon);
        },
    },
    methods: {
        ...mapActions("legal/ndas", [
            "getNdas",
            "deleteNda",
            "duplicateNda",
            "generatePdf",
            "setCurrentNda",
        ]),
        ...mapMutations(["showModal"]),
        ...mapMutations("legal", ["setIframeLoaded"]),
        askAndRemoveNda(nda) {
            const modalData = {
                type: "confirm",
                title: this.$t("shared.delete_project"),
                desc: this.$t("shared.delete_project_info"),
                actionBtn: this.$t("shared.delete"),
                cancelBtn: this.$t("shared.cancel"),
                callback: () => {
                    this.deleteNda(nda);
                },
                size: "lg",
            };
            this.showModal(modalData);
        },
        async cloneNda(nda) {
            await this.duplicateNda({ ...nda, name: `${nda.name} (1)` });
            this.$emit("edit", this.nda);
        },
        async generateNda(nda) {
            this.setIframeLoaded(false);
            this.setCurrentNda(nda);
            if (this.iframeLoaded) {
                this.generatePdf();
            } else {
                this.waitForIframeAndGeneratePdf = true;
            }
        },
    },
};
</script>
